var swiper = new Swiper(".video-slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    480: {
      slidesPerView: 2
    },
    768: {
      slidesPerView: 3
    },
    1024: {
      slidesPerView: 4
    }
  },

  on: {
    slideChange: function () {
      // Pause all videos when slide changes
      document.querySelectorAll(".video-slider video").forEach(function(video){
        video.pause();
        video.currentTime = 0; // optional: reset video
      });
    }
  }
});